import { NameData } from '../types';

export async function loadNameData(gender: 'boys' | 'girls', letter: string): Promise<NameData[]> {
  try {
    const response = await import(`../data/${gender}/${letter.toLowerCase()}.json`);
    return response.names || [];
  } catch (error) {
    console.error(`Error loading name data for ${gender}/${letter}:`, error);
    return [];
  }
}

export async function findNameInAllData(searchName: string): Promise<{
  name: NameData | null;
  gender: 'boys' | 'girls' | null;
  letter: string | null;
}> {
  const normalizedSearch = searchName.toLowerCase().trim();
  const genders: Array<'boys' | 'girls'> = ['boys', 'girls'];
  const letters = 'abcdefghijklmnopqrstuvwxyz'.split('');
  
  for (const gender of genders) {
    for (const letter of letters) {
      try {
        const names = await loadNameData(gender, letter);
        const foundName = names.find(n => 
          n.name.toLowerCase() === normalizedSearch
        );
        
        if (foundName) {
          return {
            name: foundName,
            gender,
            letter
          };
        }
      } catch (error) {
        continue;
      }
    }
  }
  
  return {
    name: null,
    gender: null,
    letter: null
  };
}